import { IconButton, IconButtonProps, Typography } from '@material-ui/core';
import React from 'react';
import styled, { css } from 'styled-components';
import { directionalPadding } from './utils';
import MenuIcon from '@material-ui/icons/Menu';
import { ReactFC } from '../types';
import { ScreenContainer } from './screen';



export const hideSmallScreen = css`
  ${({ theme }) => theme.breakpoints.down('xs')} {
    display: none;  
  }
`;
export const hideLargeScreen = css`
  ${({ theme }) => theme.breakpoints.up('sm')}  {
    display: none;  
  }
`;

export const SmallPadded = styled.div`
  ${directionalPadding()}

  ${hideLargeScreen}
`;

export const SmallScreenBottomPanel = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #666666;  

  ${hideLargeScreen}
`;

export const ScreenContainerWithDrawer = ScreenContainer;

export const LargeScreenVisible = styled(IconButton)`
  ${({ theme }) => theme.breakpoints.down('xs')} {
      && {
          display: none;
      }
  }
`;

export const SmallScreenVisible = styled(IconButton)`
  ${({ theme }) => theme.breakpoints.up('sm')} {
      && {
          display: none;
      }
  }
`;

export const AppBarTitle = styled(Typography).attrs({
  variant: "h6",
})`
  && {
      margin-left: ${({ theme }) => theme.spacing(2)}px;
      margin-right: ${({ theme }) => theme.spacing(2)}px;
  }    
`;

export const MenuButtonSmallScreen: ReactFC<IconButtonProps> = (props) => {
  return (
    <SmallScreenVisible
      color="inherit"
      aria-label="open drawer"
      edge="start"
      {...props as any}
    >
      <MenuIcon />
    </SmallScreenVisible>
  );
};

export const MenuButtonLargeScreen: ReactFC<IconButtonProps> = (props) => {
  return (
    <LargeScreenVisible
      color="inherit"
      aria-label="open drawer"
      edge="start"
      {...props as any}
    >
      <MenuIcon />
    </LargeScreenVisible>
  );
};
